import { call, put, takeLatest } from 'redux-saga/effects';
import { DELETE_ORDER_FROM_EDIT_ORDER, DELETE_ORDER_FROM_EDIT_ORDER_FAILS, DELETE_ORDER_FROM_EDIT_ORDER_SUCCESS } from './../actions/editOrder';
import hanldeException from './../services/handleException';
import history from './../services/history';
import { deleteOrders } from './../utils/orders';

export function* deleteOrderFromEditOrderSaga() {
    yield takeLatest(DELETE_ORDER_FROM_EDIT_ORDER, deleteOrderFromEditOrderHandle)
}

function* deleteOrderFromEditOrderHandle(data) {
    try {
        const response = yield call(deleteOrders, data.payload)

        if (response.data.code === 10001) {
            yield put({ type: DELETE_ORDER_FROM_EDIT_ORDER_SUCCESS, response })
            history.push('/orders')
        } else {
            yield put({ type: DELETE_ORDER_FROM_EDIT_ORDER_FAILS, response })
            hanldeException(response)
        }
    } catch (error) {
        yield put({ type: DELETE_ORDER_FROM_EDIT_ORDER_FAILS, error })
        hanldeException(error)
    }
}

export default deleteOrderFromEditOrderSaga


// WEBPACK FOOTER //
// ./src/sagas/deleteOrderFromEditOrderSaga.js